import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Modal } from '../Modal';
import { Body, Heading } from '../../atoms';
export default function DonationBoxModal(param) {
    var title = param.title, children = param.children, open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ React.createElement(Modal, {
        type: "more",
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:px-9"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3",
        className: "mb-7 md:mb-9"
    }, title), /*#__PURE__*/ React.createElement(Body, {
        className: twMerge('prose', 'prose-ol:grid prose-ol:grid-cols-1 prose-ol:grid-flow-row prose-ol:auto-rows-max prose-ol:gap-4', 'prose-li:prose-ol:grid prose-li:prose-ol:grid-cols-[auto_1fr] prose-li:prose-ol:gap-4', 'prose-li:prose-ol:before:text-body-medium prose-li:prose-ol:before:font-semibold prose-li:prose-ol:before:text-red-500', 'prose-ol:count-[list-counter]', 'prose-li:prose-ol:count-inc-[list-counter]', 'prose-li:prose-ol:before:content-[counter(list-counter)_"."]')
    }, children)));
}

//# sourceMappingURL=DonationBoxModal.js.map